import './ProjectStatusTag.scss';
import { ProjectStatus } from '@belimo-retrofit-portal/logic';
import clsx from 'clsx';
import React, { memo, useMemo } from 'react';
import { FormattedMessage } from 'src/migration/react-intl';
import { Tag } from 'src/modules/common/components/Tag';

type Props = {
  projectStatus: ProjectStatus;
};

export const ProjectStatusTag = memo(({ projectStatus }: Props) => {
  const status = useMemo(() => {
    if (projectStatus === ProjectStatus.HOLD) {
      return 'disabled';
    }
    if (projectStatus === ProjectStatus.ACTIVE) {
      return 'active';
    }
    if (projectStatus === ProjectStatus.CANCELLED) {
      return 'error';
    }

    return 'success';
  }, [projectStatus]);

  return (
    <Tag status={status}>
      <FormattedMessage id={`common/project/status/${projectStatus}`}/>
    </Tag>
  );
});
